module.exports = {
	"default_hs_url": "https://webrtc-hub.fccn.pt:8448",
	"default_is_url": "https://webrtc-hub.fccn.pt:8448"
};


/*****************
 ** WEBPACK FOOTER
 ** ./config.json
 ** module id = 152
 ** module chunks = 0
 **/